export const iconMap: {[key: string]: string} = {
  e309: 'wp-audience',
  e381: 'wp-bi',
  e329: 'wp-closed-loop',
  e314: 'wp-communities',
  e313: 'wp-cx',
  e352: 'wp-digsite',
  e324: 'wp-empower',
  e317: 'wp-insightshub',
  e380: 'wp-instant-answers',
  e378: 'wp-intercept',
  e311: 'wp-livepolls',
  e316: 'wp-reputation',
  e379: 'wp-suite-cx',
  e382: 'wp-suite-cx',
  e308: 'wp-surveys',
  e315: 'wp-workforce',
}
